import { Page } from '@roc/feature-app-core';
import { Route } from 'react-router';
import {
  CapitalProviderSelector,
  LoanTypeOptions,
} from '../components/capitalProviderSelector';
import { FixFlipLoanSubmission } from '../components/fixFlipLoanSubmission';
import { SinglePropertyLoanSubmission } from '../components/singlePropertyLoanSubmission';
import { RentalPortfolioLoanSubmission } from '../components/rentalPortfolioLoanSubmission';
import { OtherBridgeLoanSubmission } from '../components/otherBridgeLoanSubmission';
import { OtherRentalLoanSubmission } from '../components/otherRentalLoanSubmission';
import { LoanSubType } from '../utils/constants';
import { StabilizedBridgeLoanSubmission } from '../components/stabilizedBridgeLoanSubmission';
import { GroundUpLoanSubmission } from '../components/groundUpLoanSubmission';

export const routeByLoanSubType = {
  [LoanSubType.FIX_AND_FLIP]: 'fixFlip',
  [LoanSubType.GROUND_UP]: 'groundUp',
  [LoanSubType.SINGLE_PROPERTY]: 'singleProperty',
  [LoanSubType.RENTAL_PORTFOLIO]: 'rentalPortfolio',
  [LoanSubType.STABILIZED_BRIDGE]: 'stabilizedBridge',
  [LoanSubType.OTHER_BRIDGE]: 'otherBridge',
  [LoanSubType.OTHER_RENTAL]: 'otherRental',
};

export const editLoanRouteByLoanSubType = {
  [LoanSubType.FIX_AND_FLIP]: 'editFixFlip',
  [LoanSubType.GROUND_UP]: 'editGroundUp',
  [LoanSubType.SINGLE_PROPERTY]: 'editSingleProperty',
  [LoanSubType.RENTAL_PORTFOLIO]: 'editRentalPortfolio',
  [LoanSubType.STABILIZED_BRIDGE]: 'editStabilizedBridge',
  [LoanSubType.OTHER_BRIDGE]: 'editOtherBridge',
  [LoanSubType.OTHER_RENTAL]: 'editOtherRental',
};

export const getThirdPartyLoanRoutesConfig = (
  basePath: string,
  baseUrl: string
) => {
  const platformUrl = window.location.origin;

  return {
    viewLoans: {
      path: `${platformUrl}/platform-app/loans`,
      url: `${platformUrl}/platform-app/loans`,
      documentTitle: 'View Loans',
    },
    submitloan: {
      path: `${basePath}/platform/submitloan`,
      url: `${baseUrl}/platform/submitloan`,
      documentTitle: 'New Loan Selection',
    },
    selectCapitalProvider: {
      path: `${basePath}/submitloan-choose-capital-provider`,
      url: `${baseUrl}/submitloan-choose-capital-provider`,
      documentTitle: 'New Loan Selection',
    },
    viewPlatformLoanSummary: (loanId?) => ({
      path: `${platformUrl}/platform-app/loan/${loanId ?? ''}`,
      url: `${platformUrl}/platform-app/loan/${loanId ?? ''}`,
      documentTitle: 'Edit Loan',
    }),
    fixFlip: (quoteNumber?) => ({
      path: `${basePath}/platform/fix-flip/:quoteNumber?`,
      url: `${baseUrl}/platform/fix-flip/${quoteNumber ?? ''}`,
      documentTitle: 'Fix & Flip Quote',
    }),
    groundUp: (quoteNumber?) => ({
      path: `${basePath}/platform/ground-up/:quoteNumber?`,
      url: `${baseUrl}/platform/ground-up/${quoteNumber ?? ''}`,
      documentTitle: 'Ground Up Quote ',
    }),
    stabilizedBridge: (quoteNumber?) => ({
      path: `${basePath}/platform/stabilized-bridge/:quoteNumber?`,
      url: `${baseUrl}/platform/stabilized-bridge/${quoteNumber ?? ''}`,
      documentTitle: 'Stabilized Bridge Quote ',
    }),
    singleProperty: (quoteNumber?) => ({
      path: `${basePath}/platform/single-property/:quoteNumber?`,
      url: `${baseUrl}/platform/single-property/${quoteNumber ?? ''}`,
      documentTitle: 'Single Property Rental Quote',
    }),
    rentalPortfolio: (quoteNumber?) => ({
      path: `${basePath}/platform/rental-portfolio/:quoteNumber?`,
      url: `${baseUrl}/platform/rental-portfolio/${quoteNumber ?? ''}`,
      documentTitle: 'Rental Portfolio Quote',
    }),
    otherBridge: (quoteNumber?) => ({
      path: `${basePath}/platform/short-term/:quoteNumber?`,
      url: `${baseUrl}/platform/short-term/${quoteNumber ?? ''}`,
      documentTitle: 'Other Loan Type Quote',
    }),
    otherRental: (quoteNumber?) => ({
      path: `${basePath}/platform/long-term/:quoteNumber?`,
      url: `${baseUrl}/platform/long-term/${quoteNumber ?? ''}`,
      documentTitle: 'Other Loan Type Quote',
    }),
    editFixFlip: (loanId?) => ({
      path: `${basePath}/platform/edit-fix-flip/:loanId?`,
      url: `${baseUrl}/platform/edit-fix-flip/${loanId ?? ''}`,
      documentTitle: 'Fix & Flip Quote',
    }),
    editGroundUp: (loanId?) => ({
      path: `${basePath}/platform/edit-ground-up/:loanId?`,
      url: `${baseUrl}/platform/edit-ground-up/${loanId ?? ''}`,
      documentTitle: 'Ground Up Quote ',
    }),
    editStabilizedBridge: (loanId?) => ({
      path: `${basePath}/platform/edit-stabilized-bridge/:loanId?`,
      url: `${baseUrl}/platform/edit-stabilized-bridge/${loanId ?? ''}`,
      documentTitle: 'Stabilized Bridge Quote ',
    }),
    editSingleProperty: (loanId?) => ({
      path: `${basePath}/platform/edit-single-property/:loanId?`,
      url: `${baseUrl}/platform/edit-single-property/${loanId ?? ''}`,
      documentTitle: 'Single Property Rental Quote',
    }),
    editRentalPortfolio: (loanId?) => ({
      path: `${basePath}/platform/edit-rental-portfolio/:loanId?`,
      url: `${baseUrl}/platform/edit-rental-portfolio/${loanId ?? ''}`,
      documentTitle: 'Rental Portfolio Quote',
    }),
    editOtherBridge: (loanId?) => ({
      path: `${basePath}/platform/edit-short-term/:loanId?`,
      url: `${baseUrl}/platform/edit-short-term/${loanId ?? ''}`,
      documentTitle: 'Other Loan Type Quote',
    }),
    editOtherRental: (loanId?) => ({
      path: `${basePath}/platform/edit-long-term/:loanId?`,
      url: `${baseUrl}/platform/edit-long-term/${loanId ?? ''}`,
      documentTitle: 'Other Loan Type Quote',
    }),
  };
};
export const getThirdPartyLoanRoutes = (basePath: string, baseUrl: string) => {
  const config = getThirdPartyLoanRoutesConfig(basePath, baseUrl);
  return {
    selectCapitalProvider: (
      <Route exact path={config.selectCapitalProvider.path}>
        <Page routeDefinition={config.selectCapitalProvider}>
          <CapitalProviderSelector />
        </Page>
      </Route>
    ),
    submitloan: (
      <Route exact path={config.submitloan.path}>
        <Page routeDefinition={config.submitloan}>
          <LoanTypeOptions />
        </Page>
      </Route>
    ),
    fixFlip: (
      <Route exact path={config.fixFlip().path}>
        <Page routeDefinition={config.fixFlip()}>
          <FixFlipLoanSubmission />
        </Page>
      </Route>
    ),
    groundUp: (
      <Route exact path={config.groundUp().path}>
        <Page routeDefinition={config.groundUp()}>
          <GroundUpLoanSubmission />
        </Page>
      </Route>
    ),
    stabilizedBridge: (
      <Route exact path={config.stabilizedBridge().path}>
        <Page routeDefinition={config.stabilizedBridge()}>
          <StabilizedBridgeLoanSubmission />
        </Page>
      </Route>
    ),
    singleProperty: (
      <Route exact path={config.singleProperty().path}>
        <Page routeDefinition={config.singleProperty()}>
          <SinglePropertyLoanSubmission />
        </Page>
      </Route>
    ),
    rentalPortfolio: (
      <Route exact path={config.rentalPortfolio().path}>
        <Page routeDefinition={config.rentalPortfolio()}>
          <RentalPortfolioLoanSubmission />
        </Page>
      </Route>
    ),
    otherBridge: (
      <Route exact path={config.otherBridge().path}>
        <Page routeDefinition={config.otherBridge()}>
          <OtherBridgeLoanSubmission />
        </Page>
      </Route>
    ),
    otherRental: (
      <Route exact path={config.otherRental().path}>
        <Page routeDefinition={config.otherRental()}>
          <OtherRentalLoanSubmission />
        </Page>
      </Route>
    ),
    editFixFlip: (
      <Route exact path={config.editFixFlip().path}>
        <Page routeDefinition={config.editFixFlip()}>
          <FixFlipLoanSubmission />
        </Page>
      </Route>
    ),
    editGroundUp: (
      <Route exact path={config.editGroundUp().path}>
        <Page routeDefinition={config.editGroundUp()}>
          <GroundUpLoanSubmission />
        </Page>
      </Route>
    ),
    editStabilizedBridge: (
      <Route exact path={config.editStabilizedBridge().path}>
        <Page routeDefinition={config.editStabilizedBridge()}>
          <StabilizedBridgeLoanSubmission />
        </Page>
      </Route>
    ),
    editSingleProperty: (
      <Route exact path={config.editSingleProperty().path}>
        <Page routeDefinition={config.editSingleProperty()}>
          <SinglePropertyLoanSubmission />
        </Page>
      </Route>
    ),
    editRentalPortfolio: (
      <Route exact path={config.editRentalPortfolio().path}>
        <Page routeDefinition={config.editRentalPortfolio()}>
          <RentalPortfolioLoanSubmission />
        </Page>
      </Route>
    ),
    editOtherBridge: (
      <Route exact path={config.editOtherBridge().path}>
        <Page routeDefinition={config.editOtherBridge()}>
          <OtherBridgeLoanSubmission />
        </Page>
      </Route>
    ),
    editOtherRental: (
      <Route exact path={config.editOtherRental().path}>
        <Page routeDefinition={config.editOtherRental()}>
          <OtherRentalLoanSubmission />
        </Page>
      </Route>
    ),
  };
};
